import { app } from '../../app';

app.component('spInfo', {
    transclude : true,
    templateUrl: require('./sp-info.html')
});


// WEBPACK FOOTER //
// ./src/portal/components/sp-info/sp-info.component.js